// extracted by mini-css-extract-plugin
export var banner = "_3j-0";
export var icon = "_3j-1";
export var message = "_3j-2";